import { render, staticRenderFns } from "./Year_Published.vue?vue&type=template&id=68cfb740&scoped=true"
import script from "./Year_Published.vue?vue&type=script&lang=js"
export * from "./Year_Published.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cfb740",
  null
  
)

export default component.exports